/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Platform_Request_Data_PlaceholderInputs */

const en_platform_request_data_placeholder = /** @type {(inputs: Platform_Request_Data_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What ${i?.name} data are you missing? A link to the page it lives on helps.`)
};

const zh_hans1_platform_request_data_placeholder = /** @type {(inputs: Platform_Request_Data_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`还缺哪些 ${i?.name} 数据？附上数据所在页面的链接会很有帮助。`)
};

const pt_br2_platform_request_data_placeholder = /** @type {(inputs: Platform_Request_Data_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Que dados de ${i?.name} estão faltando? Um link para a página onde eles estão ajuda.`)
};

const es_platform_request_data_placeholder = /** @type {(inputs: Platform_Request_Data_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Qué datos de ${i?.name} te faltan? Un enlace a la página donde están ayuda.`)
};

const fr_platform_request_data_placeholder = /** @type {(inputs: Platform_Request_Data_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quelles données ${i?.name} vous manquent ? Un lien vers la page où elles se trouvent aide.`)
};

const de_platform_request_data_placeholder = /** @type {(inputs: Platform_Request_Data_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welche ${i?.name}-Daten fehlen dir? Ein Link zur Seite, auf der sie liegen, hilft.`)
};

const ru_platform_request_data_placeholder = /** @type {(inputs: Platform_Request_Data_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Каких данных ${i?.name} вам не хватает? Ссылка на страницу, где они находятся, поможет.`)
};

const it_platform_request_data_placeholder = /** @type {(inputs: Platform_Request_Data_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quali dati di ${i?.name} ti mancano? Un link alla pagina in cui si trovano aiuta.`)
};

/**
* | output |
* | --- |
* | "What {name} data are you missing? A link to the page it lives on helps." |
*
* @param {Platform_Request_Data_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_request_data_placeholder = /** @type {((inputs: Platform_Request_Data_PlaceholderInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Request_Data_PlaceholderInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_request_data_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_platform_request_data_placeholder(inputs)
	if (locale === "es") return es_platform_request_data_placeholder(inputs)
	if (locale === "fr") return fr_platform_request_data_placeholder(inputs)
	if (locale === "de") return de_platform_request_data_placeholder(inputs)
	if (locale === "ru") return ru_platform_request_data_placeholder(inputs)
	if (locale === "it") return it_platform_request_data_placeholder(inputs)
	return en_platform_request_data_placeholder(inputs)
});